import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartPie } from '@fortawesome/free-solid-svg-icons';
import { MoneyAmount } from 'components/MoneyAmount';
import styles from './Total.scss';

export const Total = ({ totalBalance }) => (
  <div className={styles.card}>
    <div className={styles.icon}>
      <FontAwesomeIcon icon={faChartPie} />
    </div>
    <div className={styles.text}>
      <p className={styles.label}>Загальний баланс</p>
      <p className={styles.amount}>
        <MoneyAmount value={totalBalance} />
      </p>
    </div>
  </div>
);
